import * as React from 'react';
import Service from '../Service';
import { Case, CheckedBaggage } from '../../../../../Icons';
import { useServicePageProps } from '../../../../../CheckoutAdditionalService/components/hooks';
import ServiceCardDialog from '../../../../../Checkout/components/Checkout/OrderPaidServiceCards/components/ServiceCardDialog/ServiceCardDialog';
import ServicePage from '../../../../../Checkout/components/Checkout/ServicePage/ServicePage';
import { ServiceType } from '../../../../../Checkout/components/Checkout/OrderPaidServiceCards/types';
import { GdsAggregationServiceGroup } from '../../../../../Checkout/types';
import { useTranslation } from 'react-i18next';
import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import { getBaggageTexts } from './getBaggageTexts';

interface Props {
	services: GdsAggregationServiceGroup;
}

const Baggage: React.FC<Props> = ({ services }) => {
	const { t } = useTranslation('FlightInfoCard');

	const { baggageTexts, carryOnTexts } = getBaggageTexts(services.selectedServices, t);

	const servicePageProps = useServicePageProps();

	const open = () => servicePageProps.toggleModal(ServiceType.Baggage);

	return (
		<>
			{services.type === 'CarryOn' && carryOnTexts.length > 0 && (
				<Service icon={Case} selected={true} onClick={open}>
					<span>
						{t('Carry on')}: {carryOnTexts.join('; ')}
					</span>
				</Service>
			)}

			{services.type === OrderAdditionalServiceGdsServiceServiceType.Baggage && (
				<Service icon={CheckedBaggage} selected={baggageTexts.length > 0} onClick={open}>
					{baggageTexts.length > 0 ? (
						<span>
							{t('Checked baggage')}: {baggageTexts.join('; ')}
						</span>
					) : (
						<span>{t('Buy a luggage with discount up to 20%')}</span>
					)}
				</Service>
			)}

			<ServicePage>
				{childrenProps => (
					<ServiceCardDialog
						order={servicePageProps.order}
						openedModal={servicePageProps.openedModal}
						onClose={servicePageProps.toggleModal.bind(null, null)}
						passengers={servicePageProps.passengers}
						passengerLabels={servicePageProps.passengerLabels}
						{...childrenProps}
					/>
				)}
			</ServicePage>
		</>
	);
};

export default Baggage;
